import React from "react";
import styles from "./Hero.module.css";

const Hero = ({ onCtaClick }) => {
  const handleClick = () => {
    // Scroll to the About section which triggers nav to appear
    const aboutSection = document.getElementById("about");
    aboutSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className={`${styles.hero} grid-bg`}>
      <div className={styles.brackets}>
        <div className={`${styles.bracket} ${styles.topLeft}`}></div>
        <div className={`${styles.bracket} ${styles.topRight}`}></div>
        <div className={`${styles.bracket} ${styles.bottomLeft}`}></div>
        <div className={`${styles.bracket} ${styles.bottomRight}`}></div>
      </div>

      <div className={styles.content}>
        <div className={`${styles.label} mono`}>
          {`// react · react native · web3 developer`}
        </div>

        <h1 className={styles.headline}>
          Building the{" "}
          <span className={styles.highlight}>Future of the Web</span>
        </h1>

        <p className={`${styles.subtitle} mono`}>
          Always Building, Always Evolving
        </p>

        <button className={`${styles.cta} mono`} onClick={handleClick}>
          Enter Portfolio →
        </button>
      </div>
    </section>
  );
};

export default Hero;
